import { render, staticRenderFns } from "./KYCForm.vue?vue&type=template&id=5d177579&scoped=true"
import script from "./KYCForm.vue?vue&type=script&lang=js"
export * from "./KYCForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d177579",
  null
  
)

export default component.exports